import {IBook} from "@/interfaces/book.interface";

export namespace IFormBuilder {

  export type IField = IFieldSimple | IFieldSelect;

  export interface IFieldSimple {
    prop: string;
    type: FieldType;

    inputType?: string;

    required?: boolean;
    label?: string;
    placeholder?: string;
    disabled?: boolean;

    canCreate?: boolean;
    titleProp?: string;

    hidden?: boolean;
  }

  export interface IFieldSelect extends IFieldSimple {
    options: IBook.CatalogData[];
    multiple: boolean;
  }

  export enum FieldType {
    Input = 'input',
    Phone = 'phone',
    Password = 'password',
    Textarea = 'textarea',
    Select = 'select',
    Date = 'date',
    DateText = 'dateText',
    Text = 'text',
    NumberFormatted = 'numberFormatted',
    Custom = 'custom',
    SubProps = 'subProps',
    Checkbox = 'checkbox',
    Switcher = 'switcher',
  }
}
